import Vue from 'vue'
import Invoices from "./invoices.vue";
import AppBadge from "./AppBadge.vue";
import RecipeView from "./modals/RecipeView.vue";
import WaterCounter from "./water-counter.vue";
import DayWorkouts from "./day-workouts.vue";
import DayRecipes from "./day-recipes.vue";
import DayArticle from "./day-article.vue";
import DayMeditation from "./day-meditation.vue";

Vue.component('app-badge', AppBadge)
Vue.component('invoices', Invoices)
Vue.component('recipe-view-modal', RecipeView)
Vue.component('water-counter', WaterCounter)
Vue.component('day-workouts', DayWorkouts)
Vue.component('day-recipes', DayRecipes)
Vue.component('day-article', DayArticle)
Vue.component('day-meditation', DayMeditation)
